webpackJsonp([189066279150898],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(30);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createContactLink = exports.combineHeaders = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var combineHeaders = exports.combineHeaders = function combineHeaders() {
	  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createContactLink = exports.createContactLink = function createContactLink(tel, sms, facetime, email, headers) {
	  var link = void 0;
	  if (email) {
	    link = 'mailto:' + email;
	    if (headers) {
	      link += '?' + combineHeaders(headers);
	    }
	  } else if (tel) {
	    link = 'tel:' + tel;
	  } else if (sms) {
	    link = 'sms:' + sms;
	  } else if (facetime) {
	    link = 'facetime:' + facetime;
	  }
	  return link;
	};
	
	var Obfuscate = function (_Component) {
	  _inherits(Obfuscate, _Component);
	
	  function Obfuscate() {
	    _classCallCheck(this, Obfuscate);
	
	    return _possibleConstructorReturn(this, (Obfuscate.__proto__ || Object.getPrototypeOf(Obfuscate)).apply(this, arguments));
	  }
	
	  _createClass(Obfuscate, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props,
	          tel = _props.tel,
	          sms = _props.sms,
	          facetime = _props.facetime,
	          email = _props.email,
	          obfuscate = _props.obfuscate,
	          headers = _props.headers,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          href: createContactLink(tel, sms, facetime, email, headers)
	        }, others),
	        children || tel || sms || facetime || email
	      );
	    }
	  }, {
	    key: 'reverse',
	    value: function reverse(s) {
	      return s.split('').reverse().join('');
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props,
	          tel = _props2.tel,
	          sms = _props2.sms,
	          facetime = _props2.facetime,
	          email = _props2.email,
	          obfuscate = _props2.obfuscate,
	          headers = _props2.headers,
	          children = _props2.children,
	          style = _props2.style,
	          others = _objectWithoutProperties(_props2, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children', 'style']);
	
	      var obsStyle = _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override'
	      });
	
	      if (!children) {
	        obsStyle.direction = 'rtl';
	      }
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: this.handleClick.bind(this),
	          href: 'obfuscated'
	        }, others, {
	          style: obsStyle
	        }),
	        children || this.reverse(tel || sms || facetime || email).replace('(', ')').replace(')', '(')
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props,
	          tel = _props3.tel,
	          sms = _props3.sms,
	          facetime = _props3.facetime,
	          email = _props3.email,
	          headers = _props3.headers;
	
	      window.location.href = createContactLink(tel, sms, facetime, email, headers);
	    }
	  }]);
	
	  return Obfuscate;
	}(_react.Component);
	
	Obfuscate.propTypes = {
	  children: _propTypes.node,
	  tel: _propTypes.string,
	  sms: _propTypes.string,
	  facetime: _propTypes.string,
	  email: _propTypes.string,
	  headers: _propTypes.object,
	  obfuscate: _propTypes.bool,
	  style: _propTypes.object
	};
	
	Obfuscate.defaultProps = {
	  obfuscate: true
	};
	
	exports.default = Obfuscate;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (props) {
	  var type = props.type,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ['type', 'className']);
	
	  var classes = 'input';
	
	  if (className !== undefined) {
	    classes = classes + ' ' + className;
	  }
	
	  if (type === "textarea") {
	    return _react2.default.createElement('textarea', _extends({ className: classes }, rest));
	  } else {
	    return _react2.default.createElement('input', _extends({ className: classes }, rest));
	  }
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactObfuscate = __webpack_require__(140);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(28);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Heading = __webpack_require__(18);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Button = __webpack_require__(47);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(221);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContactDetails = function ContactDetails(props) {
	  var email = props.email,
	      dribbbleUrl = props.dribbbleUrl,
	      githubUrl = props.githubUrl,
	      twitterUrl = props.twitterUrl;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'contact-details', className: 'grid-wrap' },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Need to get in touch or just want to say hello?'
	      ),
	      ' You can ',
	      _react2.default.createElement(
	        _reactObfuscate2.default,
	        { email: email },
	        'email me'
	      ),
	      ' directly or by using the form below. I\'m also on ',
	      _react2.default.createElement(
	        _gatsbyPluginGoogleAnalytics.OutboundLink,
	        { href: dribbbleUrl, className: 'link-external', target: '_blank' },
	        'Dribbble'
	      ),
	      ', ',
	      _react2.default.createElement(
	        _gatsbyPluginGoogleAnalytics.OutboundLink,
	        { href: githubUrl, className: 'link-external', target: '_blank' },
	        'GitHub'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        _gatsbyPluginGoogleAnalytics.OutboundLink,
	        { href: twitterUrl, className: 'link-external', target: '_blank' },
	        'Twitter'
	      ),
	      '.'
	    )
	  );
	};
	
	var ContactForm = function ContactForm(props) {
	  var action = props.action,
	      next = props.next,
	      rest = _objectWithoutProperties(props, ['action', 'next']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: 'grid-wrap' }, rest),
	    _react2.default.createElement(
	      'form',
	      { className: 'contact-form form', action: action, method: 'POST' },
	      _react2.default.createElement('input', { type: 'hidden', name: '_next', value: next }),
	      _react2.default.createElement(
	        'p',
	        { className: 'grid grid--center sm-grid--full' },
	        _react2.default.createElement(
	          'label',
	          { className: 'label label--md grid-cell grid-cell--autoSize' },
	          'Hi, my name is'
	        ),
	        _react2.default.createElement(_Input2.default, { type: 'text', name: 'name', placeholder: 'Full Name', className: 'input--md grid-cell', required: true })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'grid grid--full' },
	        _react2.default.createElement(_Input2.default, { type: 'textarea', name: 'message', placeholder: 'How Can I Help You?', className: 'input--md grid-cell', required: true })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'grid grid--center sm-grid--full' },
	        _react2.default.createElement(
	          'label',
	          { className: 'label label--md grid-cell grid-cell--autoSize' },
	          'I can be reached at'
	        ),
	        _react2.default.createElement(_Input2.default, { type: 'email', name: '_replyto', placeholder: 'Email Address', className: 'input--md grid-cell', required: true })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { className: 'button--outline button--md u-sm-full' },
	        'Send Message'
	      )
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var meta = data.site.siteMetadata;
	  var siteUrl = meta.siteUrl,
	      email = meta.email,
	      dribbbleUrl = meta.dribbbleUrl,
	      githubUrl = meta.githubUrl,
	      twitterUrl = meta.twitterUrl;
	
	  var pageTitle = "Contact";
	  var siteTitle = pageTitle + ' \u2014 ' + meta.title;
	  var action = 'https://formspree.io/' + email;
	  var next = siteUrl + '/contact/thanks/';
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: pageTitle },
	      _react2.default.createElement('meta', { property: 'og:title', content: siteTitle })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'header-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '2', className: 'grid-wrap' },
	        pageTitle
	      )
	    ),
	    _react2.default.createElement(ContactDetails, { email: email, dribbbleUrl: dribbbleUrl, githubUrl: githubUrl, twitterUrl: twitterUrl }),
	    _react2.default.createElement(ContactForm, { action: action, next: next })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-js-fb6820630b3760798c14.js